import { useContext } from 'react';

import { ConfirmContext } from './ConfirmProvider';
import { ConfirmProps } from './ConfirmDialog.types';

export const useConfirm = (): ConfirmProps => useContext(ConfirmContext);
